import { GenericTestRouteState } from './generic-test-state'

export const CognitiveTestRouteState = GenericTestRouteState.named(
  'CognitiveTestRouteState'
)
